const listaDeVueComponentesMenus = (state) => {
    return state.items;
}

const listaDeSubmodulos = (state) => {
    return state.submodulos;
}

const listaDeRotas = (state) => {
    return state.rotas;
}

const loadingVueComponentesMenus = (state) => {
    return state.carregando
}

export {
    listaDeVueComponentesMenus,
    listaDeSubmodulos,
    listaDeRotas,
    loadingVueComponentesMenus
}